import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { global } from "../../Context/Context";
import axios from "axios";
const Widthdrawal = ({ status }) => {
  const {
    getHostByStatus1,
    getHostByStatuss1,
    widthdrawal,
    setWidthdrawal,
    widthdrawalLists,
    widthdrawalListsUpdate,
  } = useContext(global);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [id, setId] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [search, setSearch] = useState("");
  const [searchData, setSearchData] = useState([]);

  const indexOfLastUser = currentPage * entriesPerPage;
  const indexOfFirstUser = indexOfLastUser - entriesPerPage;

  // let filterValue = widthdrawal.filter((v) => {
  //   return v._id.toString() != id.toString();
  // });
  let filterValue = widthdrawal.filter((v) => {
    return v._id.toString() != id.toString();
  });
  // console.log(filterValue);
  // console.log("Search data", searchData);
  let currentUsers =
    searchData.length > 0
      ? searchData.slice(indexOfFirstUser, indexOfLastUser)
      : filterValue.slice(indexOfFirstUser, indexOfLastUser);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Pagination
  const totalPages = Math.ceil(widthdrawal.length / entriesPerPage);

  useEffect(() => {
    widthdrawalLists(status);
  }, [status]);

  const searhUser = async () => {
    try {
      setSearchData(filterValue);
      const { data } = await axios.get(
        `${process.env.REACT_APP_BASEURL1}/admin/withdrawal/search?search=${search}&status=${status}&page=${currentPage}`
      );
      console.log(data.details);
      setSearchData(data.details);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    searhUser();
  }, [search]);

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`} // Apply active style conditionally
        >
          <button onClick={() => paginate(i)} className="page-link">
            {i}
          </button>
        </li>
      );
    }

    return pageNumbers;
  };

  return (
    <>
      <section className="content-header">
        <h1>Widthdrawal List</h1>
        <ol className="breadcrumb">
          <li>
            <Link to="/admin">
              <i className="fa fa-dashboard"></i> Home
            </Link>
          </li>
          <li className="active">Widthdrawal List</li>
        </ol>
      </section>
      <section className="content">
        <div className="row">
          <div className="col-xs-12">
            <div className="box">
              <div className="box-body">
                <div className="row " style={{ padding: "16px 0px" }}>
                  <div className="entries-per-page col-md-6 ">
                    <label htmlFor="entries">Entries per page:</label>
                    <select
                      id="entries"
                      value={entriesPerPage}
                      onChange={(e) =>
                        setEntriesPerPage(parseInt(e.target.value))
                      }
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                  <div
                    class="col-md-5"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      class="main-data-single-field"
                      style={{ width: "fit-content" }}
                    >
                      <span style={{ fontWeight: "bold", marginRight: "8px" }}>
                        Search
                      </span>
                      <span>
                        <input
                          type="text"
                          id="pname"
                          name="pname"
                          style={{
                            borderRadius: "4px",
                            borderStyle: "groove",
                            width: "150px",
                          }}
                          onChange={(e) => {
                            setSearch(e.target.value);
                          }}
                          placeholder="Searh User"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <table
                  id="example1"
                  className="table table-bordered table-striped"
                >
                  <thead>
                    <tr>
                      <th>SR.</th>
                      <th>username</th>
                      <th>name</th>
                      <th>coins</th>
                      <th>ACC NO</th>
                      <th>BANK NAME</th>
                      <th>IFSC CODE</th>
                      <th>STATUS</th>
                      {status != "2" && <th>ACTION</th>}
                    </tr>
                  </thead>
                  <tbody id="ts">
                    {Array.isArray(currentUsers) &&
                      currentUsers.map((item, index) => {
                        let i = indexOfFirstUser + index + 1;
                        return (
                          <tr>
                            <td>{i}</td>
                            <td>{item?.userId?.username}</td>
                            <td>{item?.userId?.name}</td>
                            <td>{item?.coins}</td>
                            <td>{item?.accountNo}</td>
                            <td>{item?.bankName}</td>
                            <td>{item?.ifscCode}</td>
                            {/* <td>{item.status}</td> */}
                            <td>
                              {item.status == "0" ? (
                                <td>
                                  <span className="label label-info">
                                    Pending
                                  </span>
                                </td>
                              ) : item.status == "1" ? (
                                <td>
                                  <span className="label label-success">
                                    Approved
                                  </span>
                                </td>
                              ) : (
                                <td>
                                  <span className="label label-danger">
                                    Rejected
                                  </span>
                                </td>
                              )}
                            </td>
                            <td>
                              <ul
                                className="admin-action btn btn-default"
                                style={{
                                  backgroundColor: "#f4f4f4",
                                  color: "#fff !important",
                                }}
                              >
                                {status != "2" && (
                                  <li className="dropdown">
                                    <a
                                      className="dropdown-toggle"
                                      style={{ color: "black" }}
                                      data-toggle="dropdown"
                                      href="#"
                                      aria-expanded="false"
                                    >
                                      Action <span className="caret" />
                                    </a>
                                    <ul className="dropdown-menu dropdown-menu-right">
                                      {item.status == 0 ? (
                                        <>
                                          <li
                                            role="presentation"
                                            onClick={() => {
                                              // aprrovedHost({
                                              //   id: item._id,
                                              //   status: "1",
                                              // });
                                              let status = 1;
                                              widthdrawalListsUpdate(
                                                item._id,
                                                status
                                              );
                                            }}
                                          >
                                            <Link
                                              role="menuitem"
                                              tabIndex={-1}
                                              to=""
                                            >
                                              Approve
                                            </Link>
                                          </li>
                                          <li
                                            role="presentation"
                                            onClick={() => {
                                              // aprrovedHost({
                                              //   id: item._id,
                                              //   status: "2",
                                              // });
                                              let status = 2;
                                              setId(item._id);
                                              widthdrawalListsUpdate(
                                                item._id,
                                                status
                                              );
                                            }}
                                          >
                                            <Link
                                              role="menuitem"
                                              tabIndex={-1}
                                              to=""
                                            >
                                              Reject
                                            </Link>
                                          </li>
                                          <li role="presentation">
                                            <Link
                                              role="menuitem"
                                              tabIndex={-1}
                                              to={`/admin/viewwidthdrawal/${item.userId._id}`}
                                            >
                                              View
                                            </Link>
                                          </li>
                                        </>
                                      ) : item.status == 1 ? (
                                        <>
                                          <li
                                            role="presentation"
                                            onClick={() => {
                                              // aprrovedHost({
                                              //   id: item._id,
                                              //   status: "2",
                                              // });
                                              let status = 2;
                                              setId(item._id);
                                              widthdrawalListsUpdate(
                                                item._id,
                                                status
                                              );
                                            }}
                                          >
                                            <Link
                                              role="menuitem"
                                              tabIndex={-1}
                                              to=""
                                            >
                                              Reject
                                            </Link>
                                          </li>
                                          <li role="presentation">
                                            <Link
                                              role="menuitem"
                                              tabIndex={-1}
                                              to={`/admin/viewwidthdrawal/${item.userId._id}`}
                                            >
                                              View
                                            </Link>
                                          </li>
                                        </>
                                      ) : (
                                        <>
                                          <li
                                            role="presentation"
                                            onClick={() => {
                                              // aprrovedHost({
                                              //   id: item._id,
                                              //   status: "1",
                                              // });
                                              let status = 1;
                                              setId(item._id);
                                              widthdrawalListsUpdate(
                                                item._id,
                                                status
                                              );
                                            }}
                                          >
                                            <Link
                                              role="menuitem"
                                              tabIndex={-1}
                                              to=""
                                            >
                                              Approve
                                            </Link>
                                          </li>
                                          <li role="presentation">
                                            <Link
                                              role="menuitem"
                                              tabIndex={-1}
                                              to={`/admin/viewwidthdrawal/${item.userId._id}`}
                                            >
                                              View
                                            </Link>
                                          </li>
                                        </>
                                      )}
                                    </ul>
                                  </li>
                                )}
                              </ul>
                            </td>
                          </tr>
                        );
                      })}

                    {/* Repeat this row structure for each data item */}
                  </tbody>
                </table>
                {/* Pagination links */}

                <div className="row">
                  {/* Pagination */}

                  <div className="col-md-5">
                    <ul className="pagination">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          onClick={() => paginate(currentPage - 1)}
                          className="page-link dfsdfasdf"
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                      </li>
                      {currentPage > 2 && (
                        <li className="page-item disabled"></li>
                      )}
                      {renderPageNumbers()}
                      {currentPage < totalPages - 1 && (
                        <li className="page-item disabled"></li>
                      )}
                      <li
                        className={`page-item ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}
                      >
                        <button
                          onClick={() => paginate(currentPage + 1)}
                          className="page-link dfsdfasdf"
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-5">
                    <div
                      className="total-entries"
                      style={{ float: "right", marginTop: "20px" }}
                    >
                      Total entries: <b>{getHostByStatus1.length}</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Widthdrawal;
